export const numbers = ["7", "8", "9", "4", "5", "6", "1", "2", "3", "0", "."];

export const operators = ["/", "*", "+", "-"];

export const buttons = ["AC", "CE", "=", "%"];